import {createRoot} from 'react-dom/client'
// Apps
import {AuthProvider} from '@context/Auth'
import {BrandingProvider} from '@context/Branding'
import 'assets/sass/plugins.scss'
import 'assets/sass/style.react.scss'
import 'assets/sass/style.scss'
// Module stylesheets load HERE, never from a lazy route (a lazily-imported .scss may never paint).
import '@modules/chat/chat.scss'
import {ToastContainer} from 'react-toastify'
import {MetronicI18nProvider} from '_metronic/i18n/Metronici18n'
import {ThemeModeProvider} from '_metronic/partials/layout/theme-mode/ThemeModeProvider'
import {AppRoutes} from './routing/AppRoutes'

const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    <MetronicI18nProvider>
      <ThemeModeProvider>
        <AuthProvider>
          <BrandingProvider>
            <AppRoutes />
          </BrandingProvider>
        </AuthProvider>
      </ThemeModeProvider>
      <ToastContainer
        position='bottom-right'
        autoClose={4000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme='colored'
      />
    </MetronicI18nProvider>
  )
}
